// modules
import * as R from 'ramda'
// setup
import { getState } from '../../setup/redux'

export const queueView = () => R.path(['queue'], getState())
